import { render, staticRenderFns } from "./ResultadoLote.vue?vue&type=template&id=01bcdaff&"
import script from "./ResultadoLote.vue?vue&type=script&lang=js&"
export * from "./ResultadoLote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports